import { useState } from "react"

import { KeyboardArrowDownIcon, KeyboardArrowUpIcon } from "@l2r-front/l2r-icons"

import * as Styled from "./StabiloModeButton.styled"
import { ButtonConfig, ColorOption } from "./StabiloModeButton.types"

type StabiloModeButtonProps = {
    config: ButtonConfig
    isSelected: boolean
    onColorPick: (btnValue: string, color: ColorOption) => void
}

export function StabiloModeButton(props: StabiloModeButtonProps) {
    const { config, isSelected, onColorPick } = props

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const [pickedColor, setPickedColor] = useState<ColorOption | null>(config.colors ? config.colors[0] : null)

    const openMenu = (e: React.MouseEvent<HTMLElement>) => {
        if (config.colors?.length > 1) {
            e.stopPropagation()
            setAnchorEl(e.currentTarget)
        }
    }

    const pickColor = (color: ColorOption) => {
        setPickedColor(color)
        onColorPick(config.value, color)
        setAnchorEl(null)
    }

    const open = Boolean(anchorEl)

    return (
        <>
            <Styled.ToggleButton
                value={config.value}
                selected={isSelected}
                onClick={openMenu}
                buttonColor={pickedColor?.token}
            >
                {config.icon}
                {config.colors?.length > 1 && (open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />)}
            </Styled.ToggleButton >

            <Styled.ColorMenu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
                slotProps={{ paper: { sx: { p: 1, borderRadius: 2 } } }}
            >
                {config.colors?.map((c) => (
                    <Styled.ColorItem
                        key={c.name}
                        onClick={() => pickColor(c)}
                        color={c.token}
                    />
                ))}
            </Styled.ColorMenu>
        </>
    )
}